var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.375 26.0001H29.75V24.1251C29.75 19.1838 26.125 18.3863 22.7075 17.1251C21.5712 16.7038 21.7588 13.7376 22.2613 13.1838C23.4413 11.8851 24.4437 10.3626 24.4437 6.68381C24.4437 2.97256 22.0225 1.00006 19.125 1.00006C18.7051 0.998167 18.2862 1.04006 17.875 1.12506M22.25 26.0001V24.1251C22.25 19.1838 18.625 18.3863 15.2075 17.1251C14.0713 16.7038 14.2587 13.7376 14.7612 13.1838C15.9412 11.8851 16.9438 10.3626 16.9438 6.68381C16.9438 2.97256 14.5225 1.00006 11.625 1.00006C8.7275 1.00006 6.30625 2.97256 6.30625 6.68131C6.30625 10.3588 7.30625 11.8813 8.48875 13.1813C8.98875 13.7351 9.17875 16.7013 8.0425 17.1226C4.68625 18.3638 1 19.1463 1 24.1251V26.0001H22.25Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users-icon.99b9670e.svg";
export { ForwardRef as ReactComponent };